<div [hidden]="true">
  <ng-template contentHost></ng-template>
</div>
